import { Select } from "./Select";
export default Select;
